/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { JSCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function onBackCatcher(cb) {
    /**
     * 拦截手淘 WebView 的 Back 事件: http://h5.alibaba-inc.com/api/TaobaoClient-API.html#%E6%8B%A6%E6%88%AA%E6%89%8B%E6%B7%98-WebView-%E7%9A%84-Back-%E4%BA%8B%E4%BB%B6
     * 手淘导航栏的左上角的返回按钮，或 Android 系统的返回按钮，都可以令当前页面回退到上一历史，或者关闭当前 WebView（如果不存在可以回退的历史）。
     * WindVane 在手淘中提供了拦截 Native Back 的机制，使得 JS 可以控制这一返回过程.
     * 例如可以通过调用 WebAppInterface.pop 这一 API 跳过历史记录直接关闭 WebView。
     * 要拦截 Native Back，首先要在页面中调用 JSBridge WebAppInterface.enableHookNativeBack，开启拦截 Native Back 的功能。
     * 然后在页面中实现一个控制方法 _windvane_backControl，每次 Native Back 时都会调用该方法。
     * 如果方法返回 'true'，就会停止客户端的返回逻辑，并通过 wvBackClickEvent 事件通知 JS。如果返回其它值，则会继续客户端的返回逻辑（不拦截）。
     * @returns
     */
    JSCall('WebAppInterface.enableHookNativeBack', {});
    // eslint-disable-next-line no-underscore-dangle
    window._windvane_backControl = function () {
        // 返回 'true' 即可拦截手淘的 Native Back
        return 'true';
    };
    var handler = function () {
        if (typeof cb !== 'function') {
            return;
        }
        cb();
    };
    document.addEventListener('wvBackClickEvent', handler, false);
    return function () {
        // eslint-disable-next-line no-underscore-dangle
        window._windvane_backControl = function () {
            return 'false';
        };
        document.removeEventListener('wvBackClickEvent', handler, false);
    };
}

export { onBackCatcher as default };
